<template>
  <div class="start-port-search-container">
    <el-popover
      trigger="click"
      placement="bottom-start"
      transition="el-zoom-in-top"
      :popper-class="popperClassStr"
      :close-delay="300"
      class="port-popover"
      v-model="show"
      @after-enter="handleAfterEnter"
      v-input-focus
      :append-to-body="true"
    >
      <div slot="reference" class="popover-trigger" @click="triggerClick">
        <el-autocomplete
          v-input-focus
          class="auto-port-search"
          slot="reference"
          :trigger-on-focus="false"
          :value="value"
          :fetch-suggestions="searchPortStartList"
          @select="handleSelect"
          @input="handleInput"
          @change="handleChange"
          :debounce="0"
          :popper-class="
            zLower
              ? 'auto-port-search-popper-class z-lower'
              : 'auto-port-search-popper-class'
          "
          :placeholder="placeholder || $t('message.index.search.pol')"
          :popper-append-to-body="true"
          placement="bottom-start"
        >
          <template v-slot="{ item }">
            <AutoPortTemplate :detail="item"></AutoPortTemplate>
          </template>
        </el-autocomplete>
      </div>
      <div class="port-recommend-panel">
        <div class="tab-list">
          <div class="list-wrapper" id="moveTabStartPort">
            <div
              :class="+index === +searchTab ? 'tab-item--active' : ''"
              class="tab-item"
              v-for="(item, index) in routeOptions"
              :key="index"
              @click="switchTab(index)"
            >
              {{ $i18n.locale === "cn" ? item.name : item.nameEn }}
            </div>
          </div>
          <div class="tab-item-line" :style="moveTab.styleStr"></div>
          <div class="tab-list-bottom-line"></div>
        </div>
        <div class="route-panel">
          <div class="wrapper">
            <div
              @click="portClick(item)"
              class="panel-item"
              v-for="(item, index) in routeOptions[searchTab].list"
              :key="index"
            >
              <div class="line-1">{{ item.nameCn }}</div>
              <div class="line-2">{{ item.nameEn  || item.name  }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { MoveTab } from "@/utils/tool";
import { portStartListRefresh, portStartSelect } from "@/utils/mUtils";
import AutoPortTemplate from "@/components/input/AutoPortTemplate.vue";
import { queryStartPort } from "@/api/common.js";
export default {
  componentName: "start-port-search",
  components: { AutoPortTemplate },
  props: {
    value: "",
    zLower: {
      default: false,
      type: Boolean,
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      routeOptions: [
        {
          id: -1,
          name: "热门港口",
          nameEn: "Popular",
          list: [],
        },
      ],
      show: false,
      searchTab: 0,
      moveTab: {},
    };
  },
  // 错位的解决方案 原因可能出在disabled上
  computed: {
    // zLower?'z-lower port-search-popover-class':'port-search-popover-class'
    popperClassStr() {
      let resList = ["port-search-popover-class"];
      if (this.zLower) {
        resList.push("z-lower");
      }
      if (this.disablePopover) {
        resList.push("port-search-popover-class--disabled");
      }
      return resList.join(" ");
    },
    disablePopover() {
      if (this.value) return true;
      else return false;
    },
  },

  created() {},
  mounted() {
    this.initRecommend();
    this.$on("force-to-close-popover", () => {
      console.log("==========start port 组件 force-to-close-popover");
      this.show = false;
    });
  },
  methods: {
    // 初始化推荐面板
    async initRecommend() {
      let data = {
        name: "",
      };
      let res = await queryStartPort(data);
      if (res && res.length > 0) {
        let resList = res || [];
        resList = res.filter(item => {
          if(item.id) return true;
          return false
        });

        let list = portStartListRefresh(resList, "") || [];
        this.routeOptions[0].list = list.slice(0, 10);
      }

      // console.log("==========港口推荐面板", this.routeOptions);
    },
    // 初始化tab的宽度数据
    initMoveTab() {
      this.moveTab = new MoveTab("#moveTabStartPort").switch(this.searchTab);
    },
    //wizard 起始港下拉选 ============================================================================
    async searchPortStartList(qs, cb) {
      var data = {
        name: qs,
      };
      let res = await queryStartPort(data);
      if (res && res.length > 0) {
        let list = res || [];
        list = res.filter(item => {
          if(item.id) return true;
          return false
        });
        cb(portStartListRefresh(list, qs));
      } else {
        cb([]);
      }
    },
    //单选起始港下拉框
    handleSelect(e) {
      console.log("==========触发 select事件:", e);
      portStartSelect(e);
      this.$emit("select", e);
      this.show = false;
    },
    handleInput(e) {
      this.$emit("input", e);
      this.show = false;
    },
    triggerClick() {},
    handleChange(e) {
      console.log("==========触发 change事件:", e);
      this.$emit("change", e);
    },
    switchTab(index) {
      // 切换tab
      this.searchTab = index;
      this.moveTab = this.moveTab.switch(index);
    },
    handleAfterEnter() {
      console.log("==========弹层显示动画完成");
      this.initMoveTab();
      console.log("==========宽度计算完成", this.moveTab);
    },
    // 选择推荐的港口
    portClick(item) {
      this.handleSelect(item);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/tool.scss";
.start-port-search-container {
  width: 100%;
  height: 100%;
  .port-popover {
    width: 100%;
    height: 100%;
    display: block;
    /deep/ .el-popover {
      display: none !important;
    }
    .popover-trigger {
      width: 100%;
      height: 100%;
      .auto-port-search {
        width: 100%;
        height: 100%;
        /deep/ .el-input {
          width: 100%;
          height: 100%;
          .el-input__inner {
            width: 100%;
            height: 100%;
            background-color: transparent;
            border: none;
            // 此处需要自定义
            padding: 0px 15px 0 46px;
            &:focus {
              border-color: transparent;
            }
            &:hover {
              border-color: transparent;
              background-color: transparent;
            }
          }
        }
        @include statusIsFocusLine();
        &.status-is-focus {
          &:after {
            width: 100%;
          }
        }
      }
    }
    @include statusIsFocusLine();
  }

  .status-is-focus {
    &:after {
      width: 100%;
    }
  }
}
</style>

<style lang="scss">
// 下拉列表
.auto-port-search-popper-class {
  border-radius: 6px;
  &.el-autocomplete-suggestion {
    .el-autocomplete-suggestion__wrap {
      padding: 4px 0;
    }
    li {
      padding: 0 0;
    }
    li:hover {
      background-color: #fff;
    }
  }
}
// 推荐面板
.port-search-popover-class {
  &.port-search-popover-class--disabled {
    display: none !important;
  }

  border-radius: 6px;
  $containerWidth: 674px;
  min-width: 0;
  padding: 0px;
  width: $containerWidth;
  position: relative;
  .port-recommend-panel {
    width: 100%;
    height: 100%;
    .tab-list {
      height: 48px;
      width: 100%;
      margin: 0 20px;
      position: relative;
      .list-wrapper {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        .tab-item {
          cursor: pointer;
          margin-right: 30px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.35s;
          font-weight: bold;
          color: #8a8e9f;
          &:hover {
            color: var(--theme);
          }
          &.tab-item--active {
            color: var(--theme);
          }
          &:nth-last-child(1) {
            margin-right: 0;
          }
        }
      }
      .tab-item-line {
        height: 2px;
        background: var(--theme);
        border-radius: 1px;
        position: absolute;
        left: 0px;
        bottom: 0px;
        transition: all 0.35s;
      }
      .tab-list-bottom-line {
        width: $containerWidth;
        height: 1px;
        background: #edeff2;
        position: absolute;
        left: -21px;
        bottom: 0px;
      }
    }
    .route-panel {
      padding: 10px;
      width: 100%;
      max-height: 298px;
      overflow-y: auto;
      .wrapper {
        width: 100%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .panel-item {
          width: calc(100% / 5);
          height: 54px;
          border-radius: 6px;
          font-size: 12px;
          font-weight: 500;
          color: #4a4a4b;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          padding: 0 10px;
          cursor: pointer;
          transition: all 0.35s;
          &:hover {
            background-color: rgba(var(--theme-rgb), 0.1);
            color: var(--theme);
          }
          .line-1 {
            font-weight: bold;
            width: 100%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          .line-2 {
            margin-top: 3px;
            width: 100%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
    }
  }
}
</style>